import { render, staticRenderFns } from "./PlayerBadge.vue?vue&type=template&id=ac25261a&scoped=true&"
import script from "./PlayerBadge.vue?vue&type=script&lang=js&"
export * from "./PlayerBadge.vue?vue&type=script&lang=js&"
import style0 from "./PlayerBadge.vue?vue&type=style&index=0&id=ac25261a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac25261a",
  null
  
)

export default component.exports